import React, { useState, useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./custom_carosal.css";
import { IconArrow } from "../icon/index";
const Custom_Carosal = ({ item, btnClick = null, setDirection,hide=false }) => {
  const [cards, setCards] = useState(item);
  const carouselRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(0); // Reset to the first slide
    }
    setCards(item);
  }, [item]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  useEffect(() => {
    console.log(btnClick);
    if (btnClick === "left") {
      leftRef?.current && leftRef.current.click();
      setDirection(null);
    } else if (btnClick === "right") {
      rightRef?.current && rightRef.current.click();

      setDirection(null);
    }
  }, [btnClick]);

  const IconArrows = ({ onClick, className }) => (
    <button
      ref={className === "custom-arrow--right" ? rightRef : leftRef}
      className={`${className} custom-arrow`}
      onClick={(e) => {
        onClick();
      }}
    >
      {!hide&&<IconArrow />}
    </button>
  );

  return (
    <Carousel
      ref={carouselRef}
      customRightArrow={<IconArrows className="custom-arrow--right" />}
      customLeftArrow={<IconArrows className="custom-arrow--left" />}
      style={{ backgroundImage: `url('./../asset/demo.png')` }}
      responsive={responsive}
   
    >
      {cards}
    </Carousel>
  );
};

export default Custom_Carosal;
